import { get as _get } from 'lodash';
import { prettifySize } from 'utils/prettify';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '4',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Year',
    colSize: '3',
    sortable: true,
    sort: 'desc',
    col: 'year',
    columnName: 'year',
  },
  {
    title: 'Make',
    colSize: '4',
    sortable: true,
    sortName: 'make',
    sort: 'desc',
    active: false,
    col: 'make',
    columnName: 'make',
  },
  {
    title: 'Model',
    colSize: '4',
    sortable: true,
    sortName: 'model',
    sort: 'desc',
    active: false,
    col: 'model',
    columnName: 'model',
  }
];
